//
//
//
//

export default {
  block: 'inputLabel',
  props: ['text']
}



// WEBPACK FOOTER //
// ./components/blocks/InputLabel.vue